import React from "react";
import {
  FiAlertCircle,
  FiAlertTriangle,
  FiArrowLeft,
  FiArrowRight,
  FiCalendar,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiCopy,
  FiEdit2,
  FiEye,
  FiGrid,
  FiLock,
  FiMinus,
  FiMoreHorizontal,
  FiMoreVertical,
  FiPlus,
  FiPrinter,
  FiRotateCcw,
  FiSearch,
  FiSettings,
  FiShoppingCart,
  FiSmile,
  FiTag,
  FiTrash2,
  FiTrendingUp,
  FiUploadCloud,
  FiUsers,
  FiX,
  FiMoon,
  FiSliders,
} from "react-icons/fi";

import {
  RiArrowDropDownLine,
  RiCheckFill,
  RiDashboardLine,
  RiEyeOffLine,
  RiFundsBoxLine,
  RiHome5Line,
  RiLock2Line,
  RiMapPin2Line,
  RiPaintBrushLine,
  RiPhoneLine,
  RiPriceTag2Line,
  RiSafe2Line,
  RiShoppingBasketLine,
  RiStoreLine,
  RiUser2Fill,
  RiUserSmileLine,
  RiBuilding4Fill,
  RiShoppingBagLine,
  RiLogoutCircleLine,
  RiStarLine,
  RiRestaurantLine,
  RiStore3Line,
  RiCupLine,
  RiFileList3Line,
  RiGlobalLine,
  RiFunctionLine,
  RiUserFill,
  RiMailSendLine,
  RiWhatsappLine,
  RiFacebookCircleLine,
  RiInstagramLine,
  RiYoutubeLine,
  RiPhoneFill,
  RiBook3Line,
  RiMenuFoldFill,
  RiMenuUnfoldFill,
  RiCamera2Line,
  RiKey2Line,
  RiTimeLine,
  RiUserHeartFill,
  RiUserHeartLine,
  RiEmotionUnhappyLine,
  RiEmotionUnhappyFill,
  RiEmotionLine,
  RiCupFill,
  RiEmotionFill,
  RiMenuFill,
  RiUploadLine,
  RiFile3Line,
  RiRefreshLine,
  RiFilter3Fill,
  RiCellphoneLine,
  RiTrafficLightLine,
  RiHistoryLine,
  RiTeamLine,
  RiCake2Line,
  RiUserLine,
  RiWalkLine,
  RiTimerLine,
  RiRestaurant2Line,
  RiBookmark3Line,
  RiMessage3Line,
  RiFileTextLine,
  RiUserFollowLine,
  RiFileExcel2Line,
  RiMoonLine,
  RiSunFoggyLine,
  RiSunLine,
  RiNotification4Line,
  RiNotification2Line,
  RiNotification2Fill,
  RiWalletFill,
  RiCheckboxCircleLine,
  RiUploadCloud2Line,
  RiTiktokFill,
  RiMailLine,
  RiVideoOnFill,
  RiTwitterXLine,
  RiExternalLinkLine,
  RiDownloadLine,
  RiFileCloseLine,
  RiArrowDropUpLine,
} from "react-icons/ri";
import { BsShare } from "react-icons/bs";
import { IoCloudUploadOutline } from "react-icons/io5";
import { FaPlay, FaComments } from "react-icons/fa";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi2";
import {
  MdOnlinePrediction,
  MdOutlineCardTravel,
  MdOutlineCastForEducation,
  MdOutlineFavoriteBorder,
  MdOutlineHealthAndSafety,
  MdOutlineModeComment,
  MdOutlineRamenDining,
  MdOutlineSolarPower,
  MdPayment,
  MdWorkspacePremium,
} from "react-icons/md";
import { SlDislike, SlLike } from "react-icons/sl";
import { BiChair, BiHotel, BiRestaurant, BiShoppingBag } from "react-icons/bi";
import { PiDressBold } from "react-icons/pi";
import { GiHeartNecklace } from "react-icons/gi";

export const GetIconByName = (iconName) => {
  switch (iconName) {
    case "sales":
      return <RiShoppingBasketLine />;
    case "purchasing":
      return <RiPriceTag2Line />;
    case "inventory":
      return <RiSafe2Line />;
    case "report":
      return <RiFundsBoxLine />;
    case "team":
      return <FiUsers />;
    case "user-confirm":
      return <RiUserFollowLine />;
    case "users":
      return <RiUserSmileLine />;
    case "home":
      return <RiHome5Line />;
    case "bell":
      return <RiNotification4Line />;
    case "excel":
      return <RiFileExcel2Line />;
    case "moon":
      return <RiMoonLine />;
    case "morning":
      return <RiSunFoggyLine />;
    case "lunch":
      return <RiSunLine />;
    case "tag":
      return <FiTag />;
    case "trend-up":
      return <FiTrendingUp />;
    case "plus":
      return <FiPlus />;
    case "like":
      return <SlLike />;
    case "dislike":
      return <SlDislike />;
    case "chevronDown":
      return <FiChevronDown />;
    case "chevron-up":
      return <FiChevronUp />;
    case "lock":
      return <FiLock />;
    case "cloud-up":
      return <FiUploadCloud />;
    case "upload":
      return <RiUploadLine />;
    case "alertCircle":
      return <FiAlertCircle />;
    case "chevron-left":
      return <FiChevronLeft />;
    case "chevron-right":
      return <FiChevronRight />;
    case "cross":
      return <FiX />;
    case "alert-triangle":
      return <FiAlertTriangle />;
    case "calender":
      return <FiCalendar />;
    case "search":
      return <FiSearch />;
    case "bell":
      return <RiNotification2Line />;
    case "bell-fill":
      return <RiNotification2Fill />;
    case "dots":
      return <FiMoreHorizontal />;
    case "document":
      return <RiFile3Line />;
    case "dots-v":
      return <FiMoreVertical />;
    case "cart":
      return <FiShoppingCart />;
    case "copy":
      return <FiCopy />;
    case "printer":
      return <FiPrinter />;
    case "eye":
      return <FiEye />;
    case "pencil":
      return <FiEdit2 />;
    case "rotate":
      return <FiRotateCcw />;
    case "arrow-left":
      return <FiArrowLeft />;
    case "arrow-right":
      return <FiArrowRight />;
    case "dashboard":
      return <FiGrid />;
    case "settings":
      return <FiSettings />;
    case "smile":
      return <FiSmile />;
    case "category":
      return <RiDashboardLine />;
    case "check":
      return <RiCheckFill />;
    case "paintbrush":
      return <RiPaintBrushLine />;
    case "eyeOff":
      return <RiEyeOffLine />;
    case "logout":
      return <RiLock2Line />;
    case "profile":
      return <RiUser2Fill />;
    case "walk":
      return <RiWalkLine />;
    case "timer":
      return <RiTimerLine />;
    case "user-line":
      return <RiUserLine />;
    case "trash":
      return <FiTrash2 />;
    case "minus":
      return <FiMinus />;
    case "store":
      return <RiStoreLine />;
    case "birthday":
      return <RiCake2Line />;
    case "phone":
      return <RiPhoneLine />;
    case "map-pin":
      return <RiMapPin2Line />;
    case "point":
      return <RiMapPin2Line />;
    case "traffic":
      return <RiTrafficLightLine />;
    case "arrow-down":
      return <RiArrowDropDownLine />;
    case "arrow-up":
      return <RiArrowDropUpLine />;
    case "download":
      return <RiDownloadLine />;
    case "warehouse":
      return <RiBuilding4Fill />;
    case "order":
      return <RiShoppingBagLine />;
    case "logout-circle":
      return <RiLogoutCircleLine />;
    case "star":
      return <RiStarLine />;
    case "restaurant-menu":
      return <RiRestaurantLine />;
    case "restaurant-store":
      return <RiStore3Line />;
    case "restaurant":
      return <RiRestaurant2Line />;
    case "cup":
      return <RiCupLine />;
    case "bookmark":
      return <RiBookmark3Line />;
    case "message":
      return <RiMessage3Line />;
    case "note":
      return <RiFileTextLine />;
    case "history":
      return <RiHistoryLine />;
    case "team":
      return <RiTeamLine />;
    case "wallet-fill":
      return <RiWalletFill />;
    case "file":
      return <RiFileList3Line />;
    case "glob":
      return <RiGlobalLine />;
    case "function":
      return <RiFunctionLine />;
    case "user":
      return <RiUserFill />;
    case "mail":
      return <RiMailSendLine />;
    case "facebook":
      return <RiFacebookCircleLine />;
    case "whatsapp":
      return <RiWhatsappLine />;
    case "twitter":
      return <RiTwitterXLine />;
    case "link":
      return <RiExternalLinkLine />;
    case "instagram":
      return <RiInstagramLine />;
    case "youtube":
      return <RiYoutubeLine />;
    case "comment":
      return <MdOutlineModeComment />;
    case "phone-fill":
      return <RiPhoneFill />;
    case "cell-phone":
      return <RiCellphoneLine />;
    case "wallet":
      return <RiBook3Line />;
    case "hide-menu":
      return <RiMenuFoldFill />;
    case "show-menu":
      return <RiMenuUnfoldFill />;
    case "camera":
      return <RiCamera2Line />;
    case "key":
      return <RiKey2Line />;
    case "filtter":
      return <RiFilter3Fill />;
    case "time":
      return <RiTimeLine />;
    case "cup-fill":
      return <RiCupFill />;
    case "heart":
      return <RiUserHeartLine />;
    case "heart-fill":
      return <RiUserHeartFill />;
    case "happy":
      return <RiEmotionLine />;
    case "happy-fill":
      return <RiEmotionFill />;
    case "unhappy":
      return <RiEmotionUnhappyLine />;
    case "unhappy-fill":
      return <RiEmotionUnhappyFill />;
    case "menu":
      return <RiMenuFill />;
    case "refresh":
      return <RiRefreshLine />;
    case "check-box-circle":
      return <RiCheckboxCircleLine />;
    case "upload-cloud":
      return <RiUploadCloud2Line />;
    case "moon":
      return <FiMoon />;
    case "share":
      return <BsShare />;
    case "upload":
      return <IoCloudUploadOutline />;
    case "tiktok":
      return <RiTiktokFill />;
    case "email":
      return <RiMailLine />;
    case "video":
      return <RiVideoOnFill />;
    case "play":
      return <FaPlay />;
    case "h-wrrow-right":
      return <HiArrowRight />;
    case "h-wrrow-left":
      return <HiArrowLeft />;
    case "comments":
      return <FaComments />;
    case "file-close":
      return <RiFileCloseLine />;
    case "hotel":
      return <BiHotel />;
    case "supermarket":
      return <BiShoppingBag />;
    case "online":
      return <MdOnlinePrediction />;
    case "electronics&furniture":
      return <BiChair />;
    case "health&insurance":
      return <MdOutlineHealthAndSafety />;
    case "fashion":
      return <PiDressBold />;
    case "restaurant":
      return <BiRestaurant />;
    case "dining":
      return <MdOutlineRamenDining />;
    case "travel":
      return <MdOutlineCardTravel />;
    case "premiumoffers":
      return <MdWorkspacePremium />;
    case "favorite":
      return <MdOutlineFavoriteBorder />;
    case "education":
      return <MdOutlineCastForEducation />;
    case "solar":
      return <MdOutlineSolarPower />;
    case "Auto":
      return <FiSliders />;
    case "Leisure & Lifestyle":
      return <FiSliders />;
    case "Jewellery":
      return <GiHeartNecklace />;
    case "Pay Plans":
      return <MdPayment />;
    default:
      return;
  }
};
